import { current } from '../helpers'
import { blogsMessageBoardsPath } from '../routes'
import SelectAllController from './select_all_controller'

const MESSAGE_BOARDS_FRAME_ID = 'blog_message_boards'

export default class extends SelectAllController {
  static targets = [
    'projectSelect', 'submitButton', 'messageBoardsContainer',
    'projectStep', 'boardStep'
  ]

  connect () {
    const frame = document.getElementById(MESSAGE_BOARDS_FRAME_ID)
    if (frame) this.initialEmptyState = frame.innerHTML
  }

  selectProject () {
    this.resetSubmitButton()
    if (this.projectId) {
      this.loadMessageBoards()
      this.setStepState(this.projectStepTarget, 'done')
      this.setStepState(this.boardStepTarget, 'active')
    } else {
      this.resetMessageBoards()
      this.setStepState(this.projectStepTarget, 'active')
      this.setStepState(this.boardStepTarget, 'disabled')
    }
  }

  selectMessageBoard () {
    this.setStepState(this.boardStepTarget, 'done')
    this.submitButtonVisible = true
    this.submitButtonDisabled = false
  }

  // Private

  loadMessageBoards () {
    const frame = document.getElementById(MESSAGE_BOARDS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.cardsGridSkeleton())
    frame.src = blogsMessageBoardsPath(current.account.id, { project_id: this.projectId })
  }

  resetMessageBoards () {
    const frame = document.getElementById(MESSAGE_BOARDS_FRAME_ID)
    if (!frame || !this.initialEmptyState) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialEmptyState
  }

  get projectId () {
    const hidden = this.element.querySelector('input[type="hidden"][name="blog[project_id]"]')
    return hidden?.value || this.projectSelectTarget.value
  }
}
